import Api from 'src/api/Base'

class GetSpaceGroupById extends Api {
  requestUrl = `/api/spaceGroup/${this.getParams().id}`
}

export default GetSpaceGroupById
